import { render, staticRenderFns } from "./LoadingForecast.vue?vue&type=template&id=21450b90"
import script from "./LoadingForecast.vue?vue&type=script&lang=ts"
export * from "./LoadingForecast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports